<template>
  <div>
    <preloader v-if="loading" />
    <div class="woocommerce-order" v-if="!loading && error">
      <h2 class="woocommerce-notice notice-warning-msg">
        {{ $t('checkoutNotFound') }}
      </h2>
    </div>
    <div class="woocommerce-order" v-if="!loading && declined">
      <h2 class="woocommerce-notice notice-warning-msg">
        {{ $t('checkoutDeclined') }}
      </h2>
    </div>
    <div class="woocommerce-order" v-if="!loading && !declined">
      <h2
        class="woocommerce-notice woocommerce-notice--success woocommerce-thankyou-order-received"
      >
        {{ $t('thankyou') }}
      </h2>
      <section class="woocommerce-order-details">
        <h2 class="woocommerce-order-details__title">
          {{ $t('orderInformation') }}
        </h2>
        <table
          class="woocommerce-table woocommerce-table--order-details shop_table order_details"
        >
          <thead>
            <tr>
              <th class="woocommerce-table__product-name product-name">
                {{ $t('product') }}
              </th>
              <th class="woocommerce-table__product-table product-total">
                {{ $t('subtotal') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="woocommerce-table__line-item order_item"
              v-for="item in orderItems"
              :key="`${item._id}`"
            >
              <td
                class="woocommerce-table__product-name product-name"
                v-if="item.item"
              >
                {{ item.item.name_ru }}
                <strong class="product-quantity">× {{ item.count }}</strong>
              </td>
              <td
                class="woocommerce-table__product-name product-name"
                v-if="!item.item"
              >
                <strong class="product-quantity">× {{ item.count }}</strong>
              </td>
              <td class="woocommerce-table__product-total product-total">
                <span class="woocommerce-Price-amount amount"></span>
                <span
                  style="margin-left: 50px"
                  class="price-ukr"
                  v-html="'₴' + $h.formatPrice(productPrice(item))"
                />
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th scope="row">{{ $t('totalPrice') }}:</th>
              <td>
                <span class="woocommerce-Price-amount amount">
                  <span>
                    <span class="woocommerce-Price-currencySymbol">$</span>
                  </span>
                  {{ orderPriceUsd }}
                </span>
                <span
                  style="margin-left: 10px"
                  class="price-ukr"
                  v-html="orderPrice"
                />
              </td>
            </tr>
            <tr>
              <th scope="row">{{ $t('orderId') }}:</th>
              <td>{{ orderId }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('orderPhone') }}:</th>
              <td>{{ phone }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('orderEmail') }}:</th>
              <td>{{ email }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('date') }}:</th>
              <td>{{ orderDate }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('delivery') }}:</th>
              <td>{{ deliveryMethod }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('paymentMethod') }}:</th>
              <td>{{ paymentMethod }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('status') }}:</th>
              <td>
                {{ orderStatus }}
              </td>
            </tr>
          </tfoot>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { setTimeout } from 'timers'
import Preloader from '@/components/Preloader'

export default {
  name: 'OrderReceived',
  data() {
    return {
      loading: true,
      declined: false,
      error: false,
    }
  },
  components: {
    Preloader,
  },
  computed: {
    orderItems() {
      console.log('this.order.order', this.order.order)
      return this.order.order.products
    },
    orderId() {
      return this.order.order.order_id
    },
    phone() {
      return this.order.order.phone
    },
    email() {
      return this.order.order.email
    },
    orderDate() {
      return this.$h.formatDate(this.order.order.created)
    },
    orderPrice() {
      return '₴' + this.$h.formatPrice(this.order.order.payment.total)
    },
    orderPriceUsd() {
      return this.order.order.payment.totalUsd
    },
    checkoutComplete() {
      return !!this.$route.params.id
    },
    deliveryMethod() {
      switch (this.order.order.deliveryMethod) {
        case 'NP':
          return this.$t('deliveryNP')
        case 'adress':
          return this.$t('deliveryAdress')
        default:
        case 'pickup':
          return this.$t('deliveryPickup')
      }
    },
    paymentMethod() {
      switch (this.order.order.payment.method) {
        case 'PB_II':
          return this.$t('paymentPB_II')
        case 'PB_PP':
          return this.$t('paymentPB')
        case 'Mono':
          return this.$t('paymentMono')
        case 'ABank':
          return this.$t('paymentABank')
        case 'ABank2':
          return this.$t('paymentABank2')
        case 'Globus':
          return this.$t('paymentGlobus')
        case 'Whitepay':
          return this.$t('paymentWhitepay')
        case 'SlonCredit':
          return this.$t('paymentSlonCredit')
        case 'IdeaBank':
          return this.$t('paymentIdeaBank')
        case 'NovaPoshta':
          return this.$t('paymentNovaPoshta')
        case 'Paylate':
          return this.$t('paylateText')
        case 'Online':
          return this.$t('paymentFondy')
        case 'Cash_NP':
          return this.$t('paymentOnPickup')
        case 'Cash_ADR':
          return this.$t('paymentOnPickup2')
        case 'pumb':
          return this.$t('paymentPumb')
        case 'Ukr':
          return this.$t('paymentUkr')
        case 'Sense':
          return this.$t('paymentSense')
        case 'otp':
          return this.$t('paymentOTP')
        default:
          return this.$t('paymentOnPickupFromStore')
      }
    },
    orderStatus() {
      if (this.order.order.payment.method === 'Mono') {
        switch (this.order.order.payment.subStatus) {
          case 'ACTIVE':
            return this.$t('paymentStatusMono.ACTIVE')
          case 'DONE':
            return this.$t('paymentStatusMono.DONE')
          case 'RETURNED':
            return this.$t('paymentStatusMono.RETURNED')
          case 'WAITING_FOR_CLIENT':
            return this.$t('paymentStatusMono.WAITING_FOR_CLIENT')
          case 'WAITING_FOR_STORE_CONFIRM':
            return this.$t('paymentStatusMono.WAITING_FOR_STORE_CONFIRM')
          case 'CLIENT_NOT_FOUND':
            return this.$t('paymentStatusMono.CLIENT_NOT_FOUND')
          case 'EXCEEDED_SUM_LIMIT':
            return this.$t('paymentStatusMono.EXCEEDED_SUM_LIMIT')
          case 'EXISTS_OTHER_OPEN_ORDER':
            return this.$t('paymentStatusMono.EXISTS_OTHER_OPEN_ORDER')
          case 'FAIL':
            return this.$t('paymentStatusMono.FAIL')
          case 'NOT_ENOUGH_MONEY_FOR_INIT_DEBIT':
            return this.$t('paymentStatusMono.NOT_ENOUGH_MONEY_FOR_INIT_DEBIT')
          case 'REJECTED_BY_CLIENT':
            return this.$t('paymentStatusMono.REJECTED_BY_CLIENT')
          case 'CLIENT_PUSH_TIMEOUT':
            return this.$t('paymentStatusMono.CLIENT_PUSH_TIMEOUT')
          case 'REJECTED_BY_STORE':
            return this.$t('paymentStatusMono.REJECTED_BY_STORE')
          default:
            return this.$t('paymentStatus.IN_PROCESS')
        }
      } else if (
        this.order.order.payment.method === 'ABank' ||
        this.order.order.payment.method === 'ABank2'
      ) {
        switch (this.order.order.payment.subStatus) {
          case 'ADDED':
            return this.$t('paymentStatusABank.ADDED')
          case 'WAITING_FOR_CLIENT':
            return this.$t('paymentStatusABank.WAITING_FOR_CLIENT')
          case 'WAITING_FOR_STORE_CONFIRM':
            return this.$t('paymentStatusABank.WAITING_FOR_STORE_CONFIRM')
          case 'INIT_DEBIT_SENT':
            return this.$t('paymentStatusABank.INIT_DEBIT_SENT')
          case 'ACTIVE':
            return this.$t('paymentStatusABank.ACTIVE')
          case 'RETURNED':
            return this.$t('paymentStatusABank.RETURNED')
          case 'REJECTED_BY_CLIENT':
            return this.$t('paymentStatusABank.REJECTED_BY_CLIENT')
          case 'REJECTED_BY_STORE':
            return this.$t('paymentStatusABank.REJECTED_BY_STORE')
          case 'NOT_ENOUGH_MONEY_FOR_INIT_DEBIT':
            return this.$t('paymentStatusABank.NOT_ENOUGH_MONEY_FOR_INIT_DEBIT')
          case 'EXCEEDED_SUM_LIMIT':
            return this.$t('paymentStatusABank.EXCEEDED_SUM_LIMIT')
          case 'EXISTS_EXT_OTHER_OPEN_ORDER':
            return this.$t('paymentStatusABank.EXISTS_EXT_OTHER_OPEN_ORDER')
          case 'FAIL':
            return this.$t('paymentStatusABank.FAIL')
          case 'CLIENT_NOT_FOUND':
            return this.$t('paymentStatusABank.CLIENT_NOT_FOUND')
          case 'CLIENT_PUSH_TIMEOUT':
            return this.$t('paymentStatusABank.CLIENT_PUSH_TIMEOUT')
          case 'CONFIRM_TIME_EXPIRED':
            return this.$t('paymentStatusABank.CONFIRM_TIME_EXPIRED')
          case 'WRONG_CLIENT_APP_VERSION':
            return this.$t('paymentStatusABank.WRONG_CLIENT_APP_VERSION')
          case 'MOBAPP_NOT_INSTALLED':
            return this.$t('paymentStatusABank.MOBAPP_NOT_INSTALLED')
          case 'PAY_PARTS_ARE_NOT_ACCEPTABLE':
            return this.$t('paymentStatusABank.PAY_PARTS_ARE_NOT_ACCEPTABLE')
          default:
            return this.$t('paymentStatus.IN_PROCESS')
        }
      }
      return this.$t('paymentStatus.IN_PROCESS')
    },
    ...mapState(['order', 'payment']),
  },
  methods: {
    productPrice(product) {
      return product.newPrice ? product.newPrice : product.price
    },
  },
  beforeMount() {
    // reload after 1 minute (for monobank)
    if (this.payment.awaitPageReload) {
      this.$store.commit('updatePayment', { awaitPageReload: false })
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    } else {
      this.$store
        .dispatch('getOrder', this.$route.params.id)
        .then((res) => {
          this.loading = false
          if (res.paymentStatus === 'unpaid') {
            this.declined = true
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.error = true
        })
    }
  },
}
</script>

<style></style>
